module.exports = __webpack_public_path__ + "img/tpc-16.82d8e03d.jpg";